export default __webpack_public_path__ + "static/media/logo-image-access.4dc02108.svg";